import { supabase } from '../supabase';
import { getBookIntroCache, setBookIntroCache } from './cache';

// Columns fetched from bible_outlines — avoids pulling admin/timestamp cols we never use
export const OUTLINE_COLS = 'id,book_abbr,lang,level,sort_order,start_chapter,start_verse,end_chapter,end_verse,title,prefix';

// Requests in flight, so the page's own load and a prefetch for the page turn
// (or two prefetches) share one round trip.
const inFlight = new Map();

// A book's introduction and full outline in one language, as
// { intro, outline }: from the sessionStorage cache when it is there,
// otherwise fetched and stored there. Book outline pages are turned to like
// any other page, so The Bible calls this ahead of time for the book coming
// up, and the page that slides in can show the real outline.
export function fetchBookIntro(book, lang) {
  const cached = getBookIntroCache(book, lang);
  if (cached) return Promise.resolve(cached);
  const key = `${book}_${lang}`;
  if (inFlight.has(key)) return inFlight.get(key);
  const p = Promise.all([
    supabase.from('bible_book_intros')
      .select('author,time_of_writing,place_of_writing,time_period_covered,recipient,subject')
      .eq('book_abbr', book).eq('lang', lang).maybeSingle(),
    supabase.from('bible_outlines').select(OUTLINE_COLS).eq('book_abbr', book).eq('lang', lang).order('sort_order'),
  ]).then(([{ data: introData, error: e1 }, { data: outlineData, error: e2 }]) => {
    // A failed request is not cached, so the next visit tries again.
    if (e1 || e2) throw e1 || e2;
    const result = { intro: introData || null, outline: outlineData || [] };
    setBookIntroCache(book, lang, result.intro, result.outline);
    return result;
  }).finally(() => inFlight.delete(key));
  inFlight.set(key, p);
  return p;
}
